import React from "react";
import { withStyles, createStyles } from "@material-ui/core";
import { ThemeType, Classes } from "@theme";
import Body from "../typography/Body";
import { TypographyProps } from "@material-ui/core/Typography";

type Props = {
  icon: React.ReactElement<any>;
  title: string;
  children: React.ReactNode;
  classes: Classes<typeof styles>;
  variant?: TypographyProps["variant"];
};

const IconTitle = ({ classes, children, title, icon, ...props }: Props) => (
  <div className={classes.iconTitleWrapper} title={title}>
    {icon}
    <Body variant={props.variant} className={classes.title}>
      {children}
    </Body>
  </div>
);

const styles = (theme: ThemeType) =>
  createStyles({
    iconTitleWrapper: {
      display: "flex",
      color: theme.descriptionColor,
      paddingRight: 5,
      overflow: "hidden",
      alignItems: "center"
    },

    title: {
      marginLeft: 5
    },
    content: {
      wordWrap: "break-word"
    }
  });

export default withStyles(styles)(IconTitle);
